import TaskBaseService from 'services/task/TaskBaseService';
import GraphTask from 'models/task/GraphTask';
import MissionTaskState from 'models/task/state/MissionTaskState';
import TaskRepetitionState from 'models/task/repetitionState/TaskRepetitionState';

export default class GraphTaskService extends TaskBaseService {
	toModel(task) {
		return new GraphTask({
			...task,
			state: task.state && this._taskStateService.mapState(task.state, MissionTaskState, TaskRepetitionState),
		});
	}
}
